// feature/auditoria-diaria — Actuaciones urgentes view. Reuses CasesList semantics with
// urgente filter pre-applied via the API. Cases auto-flag urgent if
// termino_horas <= 8 (server-side at intake).
import React, { useEffect, useState } from "react";
import { cases as casesApi } from "../api/endpoints";
import Spinner from "../components/Spinner";
import Empty from "../components/Empty";
import { EstadoPill, SlaPill } from "../components/Pills";
import { formatTipo } from "../utils/case_taxonomy";
import CaseDetail from "./case-detail";

export default function ActuacionesUrgentes() {
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);

  function load() {
    setData(null);
    casesApi.list({ urgente: "true" })
      .then(r => setData(r.data || []))
      .catch(() => setData([]));
  }
  useEffect(() => { load(); }, []);

  return (
    <div className="col" style={{ gap: 16 }}>
      <div>
        <h1 style={{ margin: 0 }}>🚩 Actuaciones urgentes</h1>
        <div className="muted" style={{ marginTop: 4 }}>
          Casos con plazo crítico o complejidad alta. Se marcan automáticamente cuando el término ≤ 8 horas.
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !data.length ? (
          <Empty title="Sin actuaciones urgentes" message="Cuando alguien marque un caso como urgente, aparecerá aquí." />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Tipo de actuación</th><th>Accionante</th>
                <th>Radicado</th><th>Estado de la actuación</th><th>SLA</th>
              </tr>
            </thead>
            <tbody>
              {data.map(c => (
                <tr key={c.id} onClick={() => setOpenId(c.id)} style={{ cursor: "pointer" }}>
                  <td><span style={{ color: "var(--color-danger)", marginRight: 4 }}>🚩</span><strong>{c.case_number}</strong></td>
                  <td>{formatTipo(c.tipo, c.sub_tipo, c.no_aplica)}</td>
                  <td>{c.accionante_nombre || "—"}</td>
                  <td>{c.radicado}</td>
                  <td><EstadoPill c={c} /></td>
                  <td><SlaPill c={c} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <CaseDetail caseId={openId} open={!!openId} onClose={() => setOpenId(null)} onChanged={load} />
    </div>
  );
}
